<template>
  <div class="calico-loader">
    <DotLottieVue
      autoplay
      loop
      :src="lottieSource"
      class="spinner"
    />
  </div>
</template>

<script>
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';

export default {
  name: 'CalicoLoader',
  components: {
    DotLottieVue
  },
  data() {
    return {
      lottieSource: 'https://lottie.host/43e94bc0-74fb-4c91-8d6a-bb1ba154037e/IlMevFIdec.lottie',
    };
  },
}
</script>

<style lang="scss">
.calico-loader {
  display: flex;
  width: 100%;
  justify-content: center;
  z-index: $z-index-spinner;
  .spinner {
    width: 129px;
    height: 100px;
  }
}
</style>
